import GroupedContentsTab from "./GroupedContentsTab";

export default function InprogressTab({ list }) {
  return <GroupedContentsTab list={list} />;
}
